import React from 'react';
import { injectIntl } from 'react-intl';
import { getExchangeResource } from '../../utils/exchange';
import { isIndustry, isSupplemental } from '../../utils/symbol';

class Exchange extends React.PureComponent {
  render() {
    if (
      isSupplemental(this.props.assetClass) ||
      isIndustry(this.props.assetClass)
    ) {
      return (
        <span>
          {this.props.intl.formatMessage({
            id: `symbol.assetType.${this.props.assetClass}`
          })}
        </span>
      );
    }
    if (!this.props.name) {
      return null;
    }

    const resourceID = getExchangeResource(
      this.props.name,
      this.props.section,
      this.props.name === 'TSE' ? false : this.props.useLongJpName
    );
    return <span>{this.props.intl.formatMessage({ id: resourceID })}</span>;
  }
}

export default injectIntl(Exchange);
